import {
  NotificationCategory,
  NotificationCategoryLabel,
} from '@dataTypes/notification.types'

export const FILTER_SHOW_ALL = 'Show All'

export const NOTIFICATION_FILTER_CATEGORIES = [
  FILTER_SHOW_ALL,
  NotificationCategoryLabel[NotificationCategory.APPOINTMENTS],
  NotificationCategoryLabel[NotificationCategory.NOTES],
  NotificationCategoryLabel[NotificationCategory.FORMS],
  NotificationCategoryLabel[NotificationCategory.CHARTING],
  NotificationCategoryLabel[NotificationCategory.CLAIMS],
  NotificationCategoryLabel[NotificationCategory.CLINICS],
  NotificationCategoryLabel[NotificationCategory.BILLING],
  NotificationCategoryLabel[NotificationCategory.MESSAGE_CENTER],
]

export const NOTIFICATION_FILTER_STATUS = ['Read', 'Unread']

export const NOTIFICATION_FILTERS: Record<string, string[]> = {
  Category: NOTIFICATION_FILTER_CATEGORIES,
  Status: NOTIFICATION_FILTER_STATUS,
}

export const NOTIFICATION_FILTER_LABELS: Record<string, string> = {
  Category: 'Category',
  Status: 'Status',
}
